import React from "react";
import classnames from "classnames";
import { EaselSchoolsIcon } from "../../icons";
import { ToutCheckMark } from ".";
import PremiumUpgradeModal from "./PremiumUpgradeModal";

import "./PremiumBuyerUpgradeModal.scss";

interface IProps {
  handleClose: () => void;
  show: boolean;
  upgradeButton: React.ReactNode;
}

export const PremiumBuyerUpgradeHeader = () => (
  <div
    className={classnames(
      "PremiumBuyerUpgradeModal__headerPadding",
      "PremiumBuyerUpgradeModal__header"
    )}
  >
    <div className="PremiumBuyerUpgradeModal__premium">PREMIUM</div>
    <div>
      <span className="PremiumBuyerUpgradeModal__price">$59.95/year</span>
      <span className="PremiumBuyerUpgradeModal__priceComment">
        (that&apos;s less than $5/month!)
      </span>
    </div>
  </div>
);

export const PremiumBuyerUpgradeBody = ({
  upgradeButton,
}: {
  upgradeButton: React.ReactNode;
}) => (
  <div className="PremiumBuyerUpgradeModal__contentPadding">
    <div className="PremiumBuyerUpgradeModal__descriptionHeader">
      Everything in Free, plus:
    </div>
    <div className="PremiumBuyerUpgradeModal__bulletPoint">
      <ToutCheckMark />A larger selection of fonts and colors
    </div>
    <div className="PremiumBuyerUpgradeModal__bulletPoint">
      <ToutCheckMark />
      Additional upload capacity
    </div>
    <div className="PremiumBuyerUpgradeModal__bulletPoint">
      <ToutCheckMark />
      Ability to add audio
    </div>
    <div className="PremiumBuyerUpgradeModal__upgradeButton">
      {upgradeButton}
    </div>
    <div className="PremiumBuyerUpgradeModal__schoolsTooltip">
      <EaselSchoolsIcon />
      <div className="PremiumBuyerUpgradeModal__schoolsText">
        For even more features, ask your administrator to purchase a Schools
        subscription.{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.teacherspayteachers.com/TpTSchoolAccess/Teachers"
        >
          Learn More.
        </a>
      </div>
    </div>
  </div>
);

export const PremiumBuyerUpgradeModal = ({
  show,
  handleClose,
  upgradeButton,
}: IProps) => {
  return (
    <PremiumUpgradeModal
      show={show}
      handleClose={handleClose}
      body={<PremiumBuyerUpgradeBody upgradeButton={upgradeButton} />}
      header={<PremiumBuyerUpgradeHeader />}
    />
  );
};

export default PremiumBuyerUpgradeModal;
